var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{attrs:{"action":"/api/v1/takip-etiketi","label":"Takip Etiketleri","return-id":_vm.returnId,"multiple":"","chips":"","disabled":_vm.disabled},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }